import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    CircularProgress,
    Alert,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    List,
    ListItem,
    ListItemText,
    Container,
    Button,
    ButtonGroup, // Para los botones de navegación
    IconButton // Para iconos en los botones
} from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useAuth } from '../context/AuthContext';


import { format, addMonths, subMonths, isSameMonth, getMonth, getYear } from 'date-fns';
import { es } from 'date-fns/locale';
import api from '../api/axios'; // Asumiendo que 'api' es tu instancia de Axios

function ProfilePage() {
    // Asumiendo que useAuth proporciona isAuthenticated y loading
    const { isAuthenticated, loading: authLoading } = useAuth(); // Descomenta si usas useAuth
    // Si no usas useAuth, puedes manejar un isAuthenticated/authLoading básico para el ejemplo
    const [allReservas, setAllReservas] = useState([]); // Todas las reservas fetched
    const [displayedMonth, setDisplayedMonth] = useState(new Date()); // Mes que se muestra
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchReservas = async () => {
            if (!isAuthenticated) return; // Espera a que la autenticación se resuelva
            setLoading(true);
            setError('');
            try {
                // Endpoint para obtener todas las reservas del historial del usuario
                const response = await api.get('/Reservas/historial');
                setAllReservas(response.data);
                console.log(response.data);
                

            } catch (err) {
                console.error('Error fetching reservations history:', err.response?.data || err);
                setError('Error al cargar tu historial de reservas.');
            } finally {
                setLoading(false);
            }
        };

        if (!authLoading && isAuthenticated) {
            fetchReservas();
        }
    }, [isAuthenticated, authLoading]);

    // Filtra las reservas para el mes actualmente visible
    const filteredReservas = allReservas.filter(reserva =>
        isSameMonth(new Date(reserva.fechaReserva), displayedMonth)
    ).sort((a, b) => new Date(a.fechaReserva) - new Date(b.fechaReserva)); // Ordena por fecha

    const handlePreviousMonth = () => {
        setDisplayedMonth(subMonths(displayedMonth, 1));
    };

    const handleNextMonth = () => {
        setDisplayedMonth(addMonths(displayedMonth, 1));
    };

    const getTurnoText = (turno) => {
        switch (turno) {
            case "MedioDia":
                return 'Medio día';
            case "Noche":
                return 'Noche';
            default:
                return 'Desconocido';
        }
    };

     const buscarTipoReserva = (tipoReservaBase) => {
        switch (tipoReservaBase) {
            case 1:
                return 'Salon con parrillero y vajilla';
            case 2:
                return 'Parrillero con vajilla';
            case 3:
                return 'Salon o parrillero sin vajilla';
            default:
                return 'Desconocido';
        }
    }

    if (authLoading || !isAuthenticated) {
        return (
            <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <CircularProgress />
                <Typography sx={{ ml: 2 }}>Cargando...</Typography>
            </Box>
        );
    }

    return (
        <Container component="main" maxWidth="md" sx={{ my: 12 }}>
            <Typography variant="h4" component="h1" align="center" gutterBottom sx={{ mb: 4, color: 'text.primary' }}>
                Mis Reservas
            </Typography>

            {loading && (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                    <CircularProgress />
                    <Typography sx={{ ml: 2, color: 'text.secondary' }}>Cargando tus reservas...</Typography>
                </Box>
            )}

            {error && (
                <Alert severity="error" sx={{ my: 2, textAlign: 'center' }}>
                    {error}
                </Alert>
            )}

            {!loading && !error && (
                <>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 3 }}>
                        <ButtonGroup variant="outlined" aria-label="Navegación de meses">
                            <Button color= 'secondary' onClick={handlePreviousMonth} startIcon={<ArrowBackIosIcon fontSize="small" />}>
                                Anterior
                            </Button>
                            <Button disabled>
                                {format(displayedMonth, 'MMMM yyyy', { locale: es })}
                            </Button>
                            <Button color='secondary' onClick={handleNextMonth} endIcon={<ArrowForwardIosIcon fontSize="small" />}>
                                Siguiente
                            </Button>
                        </ButtonGroup>
                    </Box>

                    <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden' }}>
                        {filteredReservas.length === 0 ? (
                            <Box sx={{ p: 3, textAlign: 'center' }}>
                                <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                                    No tienes reservas para {format(displayedMonth, 'MMMM yyyy', { locale: es })}.
                                </Typography>
                            </Box>
                        ) : (
                            <TableContainer>
                                <Table sx={{ minWidth: 650 }} aria-label="historial de reservas">
                                    <TableHead sx={{ bgcolor: 'primary.light' }}>
                                        <TableRow>
                                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Fecha</TableCell>
                                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Tipo Reserva</TableCell>
                                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Turno</TableCell>
                                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Opciones Adicionales</TableCell>
                                            <TableCell align="right" sx={{ color: 'white', fontWeight: 'bold' }}>Precio Total</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {console.log(filteredReservas)}
                                        {filteredReservas.map((reserva) => (
                                            
                                            <TableRow
                                                key={reserva.id}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&:hover': { bgcolor: 'action.hover' } }}
                                            >
                                                <TableCell component="th" scope="row">
                                                    {format(new Date(reserva.fechaReserva), 'PPP', { locale: es })}
                                                </TableCell>
                                                <TableCell>{buscarTipoReserva(reserva.tipoReservaBase)}</TableCell>
                                                <TableCell>{getTurnoText(reserva.turno)}</TableCell>
                                                <TableCell>
                                                    {reserva.opcionesAdicionales && reserva.opcionesAdicionales.length > 0 ? (
                                                        <List dense disablePadding>
                                                            {reserva.opcionesAdicionales.map((opcion, index) => (
                                                                <ListItem key={index} disableGutters>
                                                                    <ListItemText
                                                                        primary={`${opcion.nombre} (${opcion.cantidad} unid.)`}
                                                                        primaryTypographyProps={{ variant: 'body2' }}
                                                                    />
                                                                </ListItem>
                                                            ))}
                                                        </List>
                                                    ) : (
                                                        <Typography variant="body2" color="text.secondary">Ninguna</Typography>
                                                    )}
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                                                        ${reserva.precioTotal.toFixed(2)}
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                    </Paper>
                </>
            )}
        </Container>
    );
}

export default ProfilePage;